module.exports = __webpack_public_path__ + "static/media/business_center-black-18dp.cb80793a.svg";